import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'HeaderModule',
  components: {
    Loading
  },
  data () {
    return {
      loading: false
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapState({
      active: state => state.sclHeaderModule.active,
      values: state => state.sclHeaderModule.values,
      isModify: state => state.sclHeaderModule.isModify
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    buttonLayoutTypeList () {
      return Constants.Layout.Header.ButtonLayoutType
    },
    buttonCountList () {
      return this.btnLayoutType === 1 ?
        [
          {value: 1, label: '1つ設置'},
          {value: 2, label: '2つ設置'},
          {value: 3, label: '3つ設置'},
          {value: 4, label: '4つ設置'}
        ] :
        [
          {value: 1, label: '1つ設置'},
          {value: 2, label: '2つ設置'}
        ]
    },
    roundCornerList () {
      return Constants.Layout.RoundCorner.sort(Utility.sortByKey('index', true))
    },

    // input
    logoImageUseFlg: {
      get () {
        return this.values.logoImageUseFlg
      },
      set (value) {
        this.setInputValue({
          keys: ['logoImageUseFlg'],
          value: value ? 1 : 0
        })
      }
    },
    lightOffBtnUseFlg: {
      get () {
        return this.values.lightOffBtnUseFlg
      },
      set (value) {
        this.setInputValue({
          keys: ['lightOffBtnUseFlg'],
          value: value ? 1 : 0
        })
      }
    },
    btnCount: {
      get () {
        return this.values.btnCount
      },
      set (value) {
        this.setInputValue({
          keys: ['btnCount'],
          value: value
        })
      }
    },
    btnLayoutType: {
      get () {
        return this.values.btnLayoutType
      },
      set (value) {
        this.setInputValue({
          keys: ['btnLayoutType'],
          value: value
        })
      }
    },
    roundCornerFlg: {
      get () {
        return this.values.roundCornerFlg
      },
      set (value) {
        this.setInputValue({
          keys: ['roundCornerFlg'],
          value: value
        })
      }
    },
    roundCornerLeftTop: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerLeftTop
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerLeftTop'],
          value: value
        })
      }
    },
    roundCornerRightTop: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerRightTop
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerRightTop'],
          value: value
        })
      }
    },
    roundCornerLeftBottom: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerLeftBottom
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerLeftBottom'],
          value: value
        })
      }
    },
    roundCornerRightBottom: {
      get () {
        return this.values.rectRoundCornerStyle.roundCornerRightBottom
      },
      set (value) {
        this.setInputValue({
          keys: ['rectRoundCornerStyle', 'roundCornerRightBottom'],
          value: value
        })
      }
    },

    // validate
    disablePostButton () {
      return false
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    btnLayoutType (to) {
      this.btnCount = 1
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      hide: 'sclHeaderModule/hide',
      reset: 'sclHeaderModule/reset',
      setLayer: 'screenConfigLayout/setLayer',
      removeLayer: 'screenConfigLayout/removeLayer'
    }),
    ...mapMutations({
      setInputValue: 'sclHeaderModule/setInputValue'
    }),

    init () {
      // this.loading = true
    },

    /**
     * レイヤー情報を設定
     */
    postData () {
      this.setLayer(this.values)
      this.hide()
    },
    /**
     * レイヤー情報を削除
     */
    removeData () {
      this.removeLayer(this.values)
      this.hide()
    },

    /**
     * テキストエリアでEnterキー押下の処理
     */
    onKeydownEnter(keyCode) {
      if (keyCode !== 13) return
      this.postData()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}